var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage404AdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 837,
    viewBox: "0 0 842 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.404 218.083C316.078 217.646 321.493 214.317 321.089 209.642C320.86 208.324 320.257 207.1 319.35 206.116C318.444 205.132 317.273 204.43 315.977 204.094C313.369 203.46 310.66 203.346 308.007 203.757L271.016 207.12C268.522 207.665 265.914 207.245 263.718 205.943C260.355 203.253 261.801 197.469 265.131 194.711C268.805 192.418 272.69 190.481 276.733 188.927C280.775 186.56 284.007 183.026 286.005 178.789C288.004 174.552 288.675 169.81 287.931 165.185C287.027 160.586 284.882 156.322 281.729 152.854C278.575 149.386 274.533 146.847 270.04 145.512C263.77 143.895 257.131 144.54 251.288 147.332C245.446 150.124 240.774 154.885 238.093 160.78C235.571 166.867 235.403 173.626 233.553 179.915C231.703 186.203 227.264 192.593 220.74 193.366C218.26 193.448 215.789 193.025 213.476 192.123C211.164 191.222 209.059 189.86 207.289 188.12C203.799 184.649 199.904 181.612 195.687 179.074C193.547 177.851 191.077 177.333 188.627 177.592C186.176 177.852 183.869 178.876 182.034 180.52C179.041 183.883 179.276 189.23 176.518 192.794C175.047 194.401 173.178 195.592 171.1 196.247C169.022 196.902 166.808 196.999 164.681 196.527C160.463 195.524 156.393 193.975 152.575 191.92C147.571 189.231 141.89 188.062 136.231 188.557C133.42 188.895 130.806 190.171 128.81 192.178C126.815 194.186 125.555 196.808 125.234 199.621C125.372 201.931 126.132 204.16 127.435 206.073C128.737 207.985 130.534 209.509 132.633 210.483C136.876 212.37 141.443 213.421 146.084 213.577C174.064 216.166 196.83 211.963 230.157 213.577C240.245 214.014 223.162 216.637 222.186 220.538C219.328 231.972 262.541 231.03 259.817 223.498C255.244 215.595 277.338 221.379 311.404 218.083Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.655 611.138C200.597 594.962 185.262 583.058 171.239 574.953C157.216 566.848 140.973 557.231 138.821 541.324C136.669 525.418 150.322 508.738 146.421 492.529C143.764 481.431 133.709 474.066 125.605 465.995C115.114 455.542 107.27 442.735 102.725 428.64C98.1797 414.545 97.0644 399.568 99.4719 384.956C101.879 370.343 107.74 356.516 116.567 344.624C125.394 332.731 136.931 323.118 150.221 316.582C163.63 309.511 179.024 307.143 193.939 309.856C208.601 313.018 222.086 323.308 226.76 337.567C230.998 350.447 227.836 364.47 227.332 377.921C226.828 391.373 230.426 407.111 242.566 413.131C259.111 421.336 277.574 406.069 288.167 390.936C313.883 354.062 328.25 310.471 329.497 265.534C330.001 247.374 328.353 229.046 331.716 211.223C335.079 193.4 344.596 175.442 361.074 167.842C382.496 157.955 407.381 168.212 428.702 178.368C451.334 189.196 476.186 202.412 483.853 226.322C492.395 253.225 475.11 281.575 453.789 299.835C432.468 318.096 406.339 330.841 387.675 351.825C369.01 372.81 360.065 407.111 378.46 428.331C395.275 447.668 424.868 446.692 450.426 445.515C475.984 444.338 506.653 447.331 518.928 469.796C530.765 491.385 518.121 518.187 502.786 537.423C477.284 569.294 444.175 594.238 406.507 609.961L199.655 611.138Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M601.452 132.599L755.674 399.713C758.734 405.019 760.342 411.037 760.337 417.161C760.332 423.286 758.714 429.301 755.646 434.602C752.578 439.902 748.168 444.302 742.86 447.357C737.552 450.412 731.533 452.016 725.408 452.006H417.065C410.941 452.016 404.921 450.412 399.613 447.357C394.305 444.302 389.895 439.902 386.828 434.602C383.76 429.301 382.142 423.286 382.137 417.161C382.132 411.037 383.74 405.019 386.799 399.713L541.021 132.599C544.073 127.282 548.474 122.865 553.779 119.793C559.084 116.721 565.106 115.103 571.237 115.103C577.367 115.103 583.389 116.721 588.694 119.793C594 122.865 598.4 127.282 601.452 132.599Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M725.476 426.28C727.083 426.282 728.662 425.862 730.055 425.06C731.447 424.258 732.604 423.104 733.409 421.713C734.213 420.322 734.637 418.743 734.638 417.136C734.639 415.529 734.216 413.951 733.412 412.559L579.19 145.479C578.394 144.08 577.242 142.918 575.851 142.109C574.46 141.301 572.88 140.875 571.271 140.875C569.662 140.875 568.081 141.301 566.69 142.109C565.299 142.918 564.147 144.08 563.351 145.479L409.129 412.559C408.326 413.951 407.903 415.529 407.904 417.136C407.904 418.743 408.328 420.322 409.133 421.713C409.937 423.104 411.094 424.258 412.487 425.06C413.879 425.862 415.459 426.282 417.066 426.28H725.476Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M570.85 339.786C576.934 339.791 582.783 337.441 587.171 333.228C591.56 329.015 594.147 323.266 594.39 317.188L597.753 241.186C597.917 237.553 597.342 233.924 596.064 230.519C594.785 227.114 592.829 224.003 590.315 221.375C587.8 218.748 584.779 216.657 581.433 215.23C578.087 213.803 574.487 213.069 570.85 213.073C567.213 213.069 563.613 213.803 560.267 215.23C556.922 216.657 553.9 218.748 551.386 221.375C548.871 224.003 546.915 227.114 545.637 230.519C544.358 233.924 543.783 237.553 543.947 241.186L547.31 317.188C547.553 323.266 550.14 329.015 554.529 333.228C558.917 337.441 564.767 339.791 570.85 339.786ZM570.85 350.514C576.171 350.514 581.373 352.092 585.797 355.048C590.221 358.004 593.669 362.206 595.705 367.122C597.742 372.037 598.274 377.447 597.236 382.665C596.198 387.884 593.636 392.678 589.874 396.44C586.111 400.203 581.317 402.765 576.099 403.803C570.88 404.841 565.471 404.308 560.555 402.272C555.639 400.236 551.437 396.788 548.481 392.364C545.525 387.939 543.947 382.738 543.947 377.417C543.947 370.282 546.781 363.439 551.827 358.394C556.872 353.348 563.715 350.514 570.85 350.514Z",
    fill: "#2A2D33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M382 583.348C382 583.348 371.73 581.212 365 587.526C365 587.526 369.326 591.085 379.503 587.142L382 583.348Z",
    fill: "#43D1B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M383.066 583C383.066 583 391.627 591.39 386.197 600C386.197 600 378.797 597.539 379.005 586.786L383.066 583Z",
    fill: "#43D1B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M391 571.437C391 571.437 387.353 565.164 370 572.747C370 572.747 371.867 576.937 379.24 576.999C386.614 577.061 388.823 574.521 391 571.437Z",
    fill: "#43D1B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M390.736 571.001C390.736 571.001 399.473 570.626 398.98 588.973C398.98 588.973 393.404 589.694 389.923 583.651C386.442 577.607 388.288 574.484 390.736 571.001Z",
    fill: "#43D1B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397 555.48C397 555.48 393.312 542.733 376 550.52C376 550.52 379.025 562.193 395.031 559.633L397 555.48Z",
    fill: "#43D1B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M402 536.447C402 536.447 394.511 523.708 379 534.044C379 534.044 383.382 545.826 400.443 540.714L402 536.447Z",
    fill: "#43D1B7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M405 519.617C405 519.617 396.546 506.051 382 517.768C382 517.768 390.073 529.725 404.82 522.89L405 519.617Z",
    fill: "#43D1B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M408 503.323C408 503.323 398.883 490.737 384 501.078C384 501.078 394.489 512.36 407.815 506.117L408 503.323Z",
    fill: "#43D1B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408 486.725C408 486.725 398.334 468.698 384 479.387C384 479.387 394.6 495.046 407.795 489.997L408 486.725Z",
    fill: "#43D1B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M408 468.054C408 468.054 397 450.008 382 462.27C382 462.27 395.437 478.181 407.828 471.253L408 468.054Z",
    fill: "#43D1B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M404.656 451.312C404.656 451.312 391.656 437.368 379 441.909C379 441.909 392.52 456.697 405 454.838L404.656 451.312Z",
    fill: "#43D1B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M401.064 434.74C401.064 434.74 385.934 416.823 376 421.909C376 421.909 387.08 435.753 402 438L401.064 434.74Z",
    fill: "#43D1B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M395.478 416.476C395.478 416.476 383.028 401.498 373 404.365C373 404.365 383.478 419.743 397 421L395.478 416.476Z",
    fill: "#43D1B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M390.558 400.521C390.558 400.521 376.63 383.974 370 386.207C370 386.207 379.694 404.167 391 403.999L390.558 400.521Z",
    fill: "#43D1B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M384 384.071C384 384.071 374.03 364.081 368 365.033C368 365.033 373.77 382.573 383.901 386L384 384.071Z",
    fill: "#43D1B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M381.809 361.275C381.809 361.275 371.205 349.333 365 349C365 349 372.893 364.578 382 365L381.809 361.275Z",
    fill: "#43D1B7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M377.901 349.03L368.159 322C368.159 322 365.835 345.738 379 354L377.901 349.03Z",
    fill: "#43D1B7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M374.721 318.565C374.721 318.565 374.297 294.834 376 293C376 293 364.001 312.067 373.941 329L374.721 318.565Z",
    fill: "#43D1B7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M398.652 555.163C398.652 555.163 410.697 548.394 417 567.515C417 567.515 406.26 574.017 397 559.812L398.652 555.163Z",
    fill: "#43D1B7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M403.538 537.685C403.538 537.685 417.571 532.693 423 549.665C423 549.665 411.992 555.795 402 541.785L403.538 537.685Z",
    fill: "#43D1B7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M405.203 520.504C405.203 520.504 416.307 509.301 431 522.232C431 522.232 420.534 532.012 405 523.559L405.203 520.504Z",
    fill: "#43D1B7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M408.222 501.891C408.222 501.891 419.693 490.246 434 502.893C434 502.893 421.26 513.005 408 504.771L408.222 501.891Z",
    fill: "#43D1B7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M408 487.35C408 487.35 416.209 469.576 431 478.512C431 478.512 421.708 494.135 408.427 490.432L408 487.35Z",
    fill: "#43D1B7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M408 466.143C408 466.143 416.129 448.215 431 457.839C431 457.839 420.483 474.05 408.517 469.039L408 466.143Z",
    fill: "#43D1B7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402 451.038C402 451.038 406.311 429.965 420 429C420 429 415.659 451.244 403.56 455L402 451.038Z",
    fill: "#43D1B7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M402 434.718C402 434.718 404.386 412.105 414 412C414 412 412.603 429.196 402.878 438L402 434.718Z",
    fill: "#43D1B7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M394 416.109C394 416.109 399.158 396.703 411 395C411 395 408.094 413.925 394.781 421L394 416.109Z",
    fill: "#43D1B7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M391 401.237C391 401.237 392.053 380.609 396.739 378C396.739 378 398.64 396.945 392.185 404L391 401.237Z",
    fill: "#43D1B7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M384 384.499C384 384.499 386.548 362.63 393.956 360C393.956 360 395.169 377.503 384.979 386L384 384.499Z",
    fill: "#43D1B7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M379 365.165C379 365.165 379.872 346.951 383.44 343C383.44 343 385.875 363.29 380.595 369L379 365.165Z",
    fill: "#43D1B7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M376.572 348.772L383.102 320C383.102 320 387.725 344.241 376 354L376.572 348.772Z",
    fill: "#43D1B7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M378.103 320.516C378.103 320.516 391.103 302.137 391 300C391 300 388.39 319.978 373 329L378.103 320.516Z",
    fill: "#43D1B7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M376.968 314C376.968 314 391.285 286.941 397 285C397 285 378.887 292.012 376 313.108L376.968 314Z",
    fill: "#43D1B7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M381.063 369L382 368.805C372.767 336.04 371.464 315.383 378.345 310.64L377.707 310C370.452 315.024 371.595 335.432 381.063 369Z",
    fill: "#444053"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M400.834 441L402 440.679C401.18 437.797 400.291 434.862 399.343 431.972C391.061 406.793 384.18 383.436 379.957 365.56L379 365C383.232 382.921 389.925 407.137 398.191 432.338C399.132 435.22 400.02 438.133 400.834 441Z",
    fill: "#444053"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M366.132 606C366.3 605.845 383.115 589.879 396.032 561.595C403.601 545.04 408.402 527.433 410.256 509.428C412.549 486.924 409.416 461.419 402.613 438L401.635 438.973C416.921 491.538 406.366 535.051 394.58 560.895C381.793 588.906 365.169 604.717 365 604.872L366.132 606Z",
    fill: "#444053"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M350 520.295C350 520.295 343.344 518.497 339 523.781C339 523.781 341.805 526.728 348.378 523.457L350 520.295Z",
    fill: "#43D1B7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M348.913 522C348.913 522 350.801 525.95 349.601 530C349.601 530 347.969 528.821 348.001 523.78L348.913 522Z",
    fill: "#43D1B7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M353 512.521C353 512.521 350.917 508.602 341 513.346C341 513.346 342.068 515.961 346.286 515.999C350.505 516.038 351.742 514.452 353 512.521Z",
    fill: "#43D1B7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M354.24 513C354.24 513 358.215 512.754 357.991 524.982C357.991 524.982 355.457 525.46 353.876 521.434C352.294 517.408 353.129 515.324 354.24 513Z",
    fill: "#43D1B7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M358 504.625C358 504.625 355.506 495.053 344 500.882C344 500.882 346.007 509.649 356.668 507.724L358 504.625Z",
    fill: "#43D1B7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M362 494.221C362 494.221 357.445 487.859 348 493.018C348 493.018 350.674 498.917 361.052 496.355L362 494.221Z",
    fill: "#43D1B7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M365 481.762C365 481.762 358.747 476.1 348 480.989C348 480.989 353.959 485.961 364.861 483.127L365 481.762Z",
    fill: "#43D1B7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M365 472.172C365 472.172 359.299 461.874 350 470.34C350 470.34 356.551 479.568 364.882 474.458L365 472.172Z",
    fill: "#43D1B7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M365 462.153C365 462.153 358.918 450.13 350 457.259C350 457.259 356.63 467.709 364.879 464.326L365 462.153Z",
    fill: "#43D1B7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365 451.039C365 451.039 358.633 443.804 350 448.701C350 448.701 357.755 455.076 364.91 452.3L365 451.039Z",
    fill: "#43D1B7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M361.83 441.627C361.83 441.627 354.827 432.663 348 435.586C348 435.586 355.29 445.093 362 443.896L361.83 441.627Z",
    fill: "#43D1B7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M361.497 430.466C361.497 430.466 353.352 422.039 348 424.426C348 424.426 353.966 430.943 362 432L361.497 430.466Z",
    fill: "#43D1B7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M357.132 420.808C357.132 420.808 349.866 410.231 344 412.258C344 412.258 350.111 423.114 358 424L357.132 420.808Z",
    fill: "#43D1B7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M352.746 410.452C352.746 410.452 344.79 403.1 341 404.092C341 404.092 346.534 412.07 353 412L352.746 410.452Z",
    fill: "#43D1B7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M350 399.905C350 399.905 343.144 388.486 339 389.018C339 389.018 342.961 399.037 349.93 401L350 399.905Z",
    fill: "#43D1B7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M347.897 386.918C347.897 386.918 342.284 380.191 339 380C339 380 343.181 388.779 348 389L347.897 386.918Z",
    fill: "#43D1B7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M347.269 379.859L341.099 363C341.099 363 339.636 377.815 348 383L347.269 379.859Z",
    fill: "#43D1B7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M343.356 359.49C343.356 359.49 343.149 346.969 344 346C344 346 337.998 356.058 342.974 365L343.356 359.49Z",
    fill: "#43D1B7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M356.059 505.623C356.059 505.623 363.877 502.005 368 512.208C368 512.208 361.019 515.674 355 508.105L356.059 505.623Z",
    fill: "#43D1B7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M362.802 494.342C362.802 494.342 370.158 491.848 373 500.332C373 500.332 367.235 503.396 362 496.398L362.802 494.342Z",
    fill: "#43D1B7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M365.114 484.047C365.114 484.047 371.085 478.958 379 484.827C379 484.827 373.364 489.286 365 485.429L365.114 484.047Z",
    fill: "#43D1B7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M365.11 472.665C365.11 472.665 371.292 466.316 379 473.217C379 473.217 372.137 478.728 365 474.24L365.11 472.665Z",
    fill: "#43D1B7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M365 462.569C365 462.569 369.997 450.719 379 456.673C379 456.673 373.342 467.086 365.262 464.623L365 462.569Z",
    fill: "#43D1B7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M365 450.693C365 450.693 369.941 439.923 379 445.707C379 445.707 372.61 455.448 365.332 452.415L365 450.693Z",
    fill: "#43D1B7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M362 441.72C362 441.72 364.635 429.551 373 429C373 429 370.351 441.833 362.958 444L362 441.72Z",
    fill: "#43D1B7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M358 430.231C358 430.231 359.965 418.062 368 418C368 418 366.84 427.259 358.768 432L358 430.231Z",
    fill: "#43D1B7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M355 420.623C355 420.623 358.032 407.184 365 406C365 406 363.287 419.098 355.453 424L355 420.623Z",
    fill: "#43D1B7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M353 410.196C353 410.196 353.894 396.685 357.781 395C357.781 395 359.372 407.39 353.989 412L353 410.196Z",
    fill: "#43D1B7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M350 400.132C350 400.132 351.272 387.519 354.978 386C354.978 386 355.587 396.125 350.489 401L350 400.132Z",
    fill: "#43D1B7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M348 389.937C348 389.937 348.355 380.132 349.774 378C349.774 378 350.757 388.93 348.628 392L348 389.937Z",
    fill: "#43D1B7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M348.142 379.46L349.775 360C349.775 360 350.933 376.402 348 383L348.142 379.46Z",
    fill: "#43D1B7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M347.118 360.321C347.118 360.321 355.06 350.188 355 349C355 349 353.412 360.023 344 365L347.118 360.321Z",
    fill: "#43D1B7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M344.505 357C344.505 357 352.009 340.185 355 339C355 339 345.507 343.357 344 356.473L344.505 357Z",
    fill: "#43D1B7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M347.568 389L348 388.895C343.883 371.124 343.334 359.919 346.381 357.35L346.1 357C342.868 359.73 343.376 370.802 347.568 389Z",
    fill: "#444053"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M361.288 435L362 434.798C361.5 433.055 360.954 431.283 360.378 429.562C355.353 414.311 351.154 400.167 348.584 389.344L348 389C350.578 399.846 354.648 414.521 359.681 429.787C360.257 431.514 360.795 433.257 361.288 435Z",
    fill: "#444053"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M339.65 534C339.743 533.904 349.242 524.214 356.541 507.04C360.813 496.989 363.525 486.301 364.576 475.372C365.883 461.707 364.097 446.22 360.248 432L359.698 432.592C368.333 464.505 362.369 490.924 355.713 506.618C348.485 523.644 339.1 533.215 339 533.312L339.65 534Z",
    fill: "#444053"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M440.908 505.173H655.864L632.593 609.961H417.637L440.908 505.173Z",
    fill: "#43D1B7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M372.776 418.108C455.335 363.024 555.347 384.883 594.727 406.237C594.727 406.237 580.872 410.508 575.827 438.924C570.783 467.341 570.144 495.723 585.916 520.676C585.916 520.676 584.033 560.123 563.822 609.994H426.885C426.885 609.994 420.529 571.489 396.619 541.795C372.709 512.101 358.215 459.101 372.776 418.108Z",
    fill: "url(#paint3_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M388.246 354.886C381.89 353.238 384.883 344.797 388.246 336.087C391.154 328.676 396.431 322.434 403.256 318.335C410.08 314.235 418.069 312.508 425.978 313.421C448.105 315.977 464.113 338.676 461.187 350.413C458.261 362.149 454.461 367.227 440.337 369.75C426.213 372.272 388.246 354.886 388.246 354.886Z",
    fill: "url(#paint4_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M465.424 363.36C465.424 363.36 484.962 380.175 492.327 402.37C499.524 423.489 472.856 449.147 464.348 449.114C456.781 449.114 447.533 443.834 442.422 430.483C437.31 417.133 456.243 364.672 456.243 364.672L465.424 363.36Z",
    fill: "url(#paint5_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M452.713 356.735C453.453 346.647 457.69 344.393 461.557 347.151C465.424 349.909 466.702 358.215 465.424 363.36C464.146 368.505 461.557 370.389 458.228 367.631C456.646 370.739 455.406 374.008 454.529 377.383C454.529 379.973 458.43 392.516 450.863 404.858C448.478 408.898 445.22 412.353 441.327 414.971C437.435 417.59 433.006 419.305 428.365 419.991C424.296 420.731 414.914 413.265 410.105 407.246C405.296 401.226 385.219 372.036 388.549 352.498C388.549 352.498 394.636 344.192 414.712 339.046C434.788 333.901 426.448 346.949 434.25 353.978C443.835 362.822 452.376 360.535 452.713 356.735Z",
    fill: "#F29C80"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M412.694 407.817C415.822 410.037 415.822 402.84 419.42 399.242C423.018 395.644 430.652 395.879 437.849 395.879C445.045 395.879 446.693 396.787 448.173 394.03C449.652 391.272 452.78 384.983 452.41 382.596C452.04 380.208 450.022 377.249 450.392 375.601C452.146 371.806 454.111 368.112 456.277 364.537C456.277 364.537 462.599 373.415 465.794 378.93C468.989 384.445 466.601 408.053 460.145 420.765C457.89 425.608 453.971 429.481 449.101 431.678C444.231 433.875 438.735 434.251 433.611 432.737C426.247 430.349 407.515 408.423 402.774 396.72C405.738 400.712 409.058 404.426 412.694 407.817ZM428.163 415.754C432.408 414.672 436.499 413.056 440.337 410.945C441.817 409.835 442.557 403.378 442.557 403.378C442.557 403.378 431.224 403.21 427.02 403.378C422.816 403.547 420.294 411.853 420.294 411.853C422.744 413.478 425.387 414.788 428.163 415.754Z",
    fill: "url(#paint6_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M672.544 491.015C672.544 491.015 682.229 435.326 676.849 429.945C673.911 426.867 671.815 423.085 670.761 418.962C669.707 414.84 669.73 410.516 670.829 406.405C672.112 403.42 672.609 400.156 672.274 396.924C671.938 393.693 670.781 390.601 668.912 387.943C665.751 383.504 663.868 373.045 669.887 372.406C675.907 371.767 677.891 381.654 677.252 385.858C676.613 390.061 680.111 394.669 682.633 390.263C685.155 385.858 690.199 375.433 690.199 375.433C688.955 371.33 688.013 355.861 691.78 354.617C695.546 353.372 698.506 358.383 698.506 358.383C698.506 358.383 699.783 330.606 701.667 329.967C703.55 329.328 708.392 332.825 709.569 339.45C710.746 346.075 714.614 358.08 714.614 362.183C714.614 366.286 708.796 382.529 708.527 382.932C708.258 383.336 710.578 394.904 710.578 395.745C710.578 396.585 710.578 400.688 713.672 434.082C715.69 455.402 718.178 499.12 714.345 532.244C698.438 542.064 672.544 519.566 672.544 491.015Z",
    fill: "url(#paint7_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M226.558 413.971C226.558 413.971 219.631 402.807 219.833 399.242C220.034 395.677 221.11 393.458 226.155 392.214C226.155 392.214 225.516 382.528 229.249 381.15C232.981 379.771 236.445 385.32 236.445 385.32C236.445 385.32 241.557 381.957 245.088 388.683C248.619 395.408 254.807 414.947 257.867 417.94C260.927 420.933 271.318 434.754 274.681 433.947C278.044 433.14 280.129 427.793 280.365 421.168C280.6 414.543 287.09 405.295 292.908 408.355C298.726 411.416 289.814 419.957 289.108 430.147C288.402 440.337 289.108 442.253 284.602 451.838C280.096 461.422 276.329 471.813 276.329 471.813C276.329 471.813 311.135 533.758 315.406 528.949C330.573 542.77 325.495 590.758 300.845 594.424C277.641 573.675 250.67 527.166 238.564 479.212C221.817 413.03 226.558 413.971 226.558 413.971Z",
    fill: "url(#paint8_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M575.962 438.924C581.006 410.508 594.861 406.237 594.861 406.237C629.154 425.464 656.381 455.177 672.544 491.015C672.544 519.566 698.438 542.064 714.244 531.975C712.058 550.774 707.854 566.176 700.322 572.095C679.472 588.506 622.672 552.556 585.983 520.676C570.279 495.723 570.918 467.307 575.962 438.924Z",
    fill: "url(#paint9_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M315.406 528.949C325.494 517.179 347.32 435.057 372.777 417.973C358.182 458.967 372.777 512.134 396.687 541.66L397.157 542.266C381.957 571.557 348.127 602.226 324.586 605.555C317.861 606.53 309.588 602.192 300.71 594.424C325.494 590.759 330.572 542.77 315.406 528.949Z",
    fill: "url(#paint10_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M410.643 640.159H479.985C481.894 640.159 483.724 639.401 485.074 638.052C486.424 636.702 487.182 634.872 487.182 632.963C487.182 632.071 486.828 631.216 486.197 630.585C485.566 629.954 484.711 629.6 483.819 629.6H410.542C409.65 629.6 408.794 629.954 408.164 630.585C407.533 631.216 407.179 632.071 407.179 632.963V636.897C407.192 637.339 407.292 637.774 407.473 638.177C407.654 638.58 407.913 638.943 408.235 639.246C408.556 639.549 408.935 639.786 409.348 639.942C409.761 640.099 410.201 640.173 410.643 640.159Z",
    fill: "#556072"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M267.418 642.816H425.473C427.612 642.836 429.725 642.358 431.648 641.422C433.571 640.487 435.25 639.117 436.554 637.422C437.857 635.727 438.75 633.753 439.162 631.655C439.573 629.556 439.492 627.391 438.925 625.329L415.385 539.004C414.564 536.077 412.801 533.502 410.369 531.679C407.938 529.855 404.973 528.884 401.933 528.915H243.877C241.739 528.896 239.625 529.373 237.703 530.309C235.78 531.245 234.101 532.614 232.797 534.309C231.493 536.004 230.6 537.978 230.189 540.077C229.778 542.175 229.859 544.34 230.426 546.402L254.134 632.727C254.947 635.626 256.685 638.18 259.082 640.001C261.48 641.823 264.407 642.811 267.418 642.816Z",
    fill: "#6B7482"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M457.992 567.815H508.368C508.943 567.815 509.41 568.282 509.41 568.857V569.765C509.41 570.341 508.943 570.808 508.368 570.808H457.992C457.416 570.808 456.949 570.341 456.949 569.765V568.857C456.949 568.282 457.416 567.815 457.992 567.815Z",
    fill: "url(#paint11_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M455.873 572.926L456.277 571.581C456.342 571.365 456.476 571.177 456.658 571.043C456.84 570.91 457.06 570.839 457.286 570.841H509.108C509.333 570.839 509.553 570.91 509.735 571.043C509.917 571.177 510.051 571.365 510.116 571.581L510.52 572.926C510.54 573 510.544 573.077 510.53 573.153C510.516 573.228 510.485 573.299 510.44 573.36C510.395 573.422 510.336 573.472 510.268 573.508C510.2 573.543 510.126 573.563 510.049 573.565H456.243C456.176 573.55 456.112 573.521 456.056 573.48C456 573.438 455.954 573.386 455.919 573.326C455.884 573.266 455.862 573.2 455.854 573.131C455.847 573.062 455.853 572.993 455.873 572.926Z",
    fill: "url(#paint12_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M460.547 567.815H505.98L505.341 562.031C505.308 561.778 505.184 561.546 504.992 561.379C504.8 561.212 504.553 561.121 504.299 561.123H462.262C462.011 561.122 461.769 561.214 461.582 561.382C461.396 561.55 461.279 561.781 461.254 562.031L460.547 567.815Z",
    fill: "url(#paint13_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M182.256 580.279C182.256 580.279 187.623 560.566 180.441 546.341C177.392 540.395 176.365 533.615 177.516 527.02C178.088 523.888 178.948 520.813 180.083 517.835",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M175.607 508.857C175.658 511.255 180.166 518.097 180.166 518.097C180.166 518.097 184.376 511.031 184.325 508.634C184.3 507.483 183.817 506.39 182.982 505.597C182.147 504.804 181.029 504.375 179.873 504.405C178.717 504.434 177.618 504.92 176.818 505.755C176.018 506.59 175.582 507.706 175.607 508.857Z",
    fill: "#0D2290"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M168.684 522.325C170.036 524.303 177.565 527.589 177.565 527.589C177.565 527.589 177.265 519.393 175.901 517.417C175.252 516.467 174.249 515.814 173.113 515.602C171.977 515.39 170.801 515.637 169.844 516.288C168.887 516.939 168.227 517.94 168.01 519.073C167.792 520.205 168.035 521.375 168.684 522.325Z",
    fill: "#0D2290"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M169.487 545.014C171.66 546.037 179.843 545.082 179.843 545.082C179.843 545.082 175.419 538.185 173.245 537.159C172.206 536.697 171.025 536.659 169.954 537.054C168.884 537.45 168.01 538.246 167.519 539.273C167.028 540.3 166.96 541.475 167.329 542.548C167.698 543.621 168.474 544.505 169.492 545.011L169.487 545.014Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M173.977 562.027C175.942 563.405 184.162 563.839 184.162 563.839C184.162 563.839 180.976 556.287 179.012 554.912C178.544 554.585 178.016 554.353 177.458 554.229C176.899 554.106 176.321 554.093 175.757 554.192C175.192 554.291 174.652 554.5 174.168 554.806C173.684 555.113 173.264 555.511 172.934 555.978C172.603 556.445 172.368 556.972 172.241 557.529C172.115 558.086 172.099 558.662 172.196 559.223C172.293 559.785 172.5 560.322 172.806 560.803C173.111 561.284 173.509 561.7 173.977 562.027Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M186.728 527.82C185.038 529.533 177.028 531.471 177.028 531.471C177.028 531.471 178.828 523.462 180.52 521.746C181.333 520.922 182.439 520.452 183.595 520.44C184.752 520.427 185.864 520.872 186.687 521.678C187.511 522.483 187.977 523.583 187.985 524.735C187.993 525.887 187.541 526.997 186.728 527.82Z",
    fill: "#0D2290"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M191.726 547.785C189.601 548.919 181.387 548.384 181.387 548.384C181.387 548.384 185.505 541.266 187.633 540.131C188.652 539.614 189.831 539.515 190.919 539.854C192.007 540.194 192.916 540.944 193.451 541.946C193.987 542.947 194.106 544.119 193.783 545.211C193.461 546.303 192.722 547.227 191.726 547.785Z",
    fill: "#0D2290"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M193.906 567.864C192.001 569.34 183.809 570.194 183.809 570.194C183.809 570.194 186.665 562.491 188.572 561.018C189.024 560.667 189.542 560.408 190.094 560.256C190.647 560.104 191.223 560.061 191.791 560.131C192.359 560.201 192.907 560.381 193.404 560.662C193.901 560.943 194.337 561.319 194.688 561.769C195.038 562.218 195.295 562.733 195.446 563.282C195.596 563.832 195.636 564.406 195.564 564.972C195.491 565.538 195.307 566.084 195.023 566.581C194.739 567.077 194.359 567.513 193.906 567.864Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M182.094 579.625C182.094 579.625 195.012 563.732 194.247 547.805C193.883 541.127 195.705 534.501 199.44 528.924C201.232 526.289 203.263 523.823 205.507 521.555",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M205.084 511.515C204.156 513.734 205.485 521.821 205.485 521.821C205.485 521.821 212.2 517.047 213.129 514.831C213.577 513.766 213.582 512.569 213.143 511.504C212.705 510.439 211.859 509.593 210.791 509.152C209.724 508.711 208.522 508.711 207.451 509.153C206.38 509.594 205.527 510.44 205.079 511.505L205.084 511.515Z",
    fill: "#43D1B7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M193.29 521.058C193.725 523.414 199.256 529.476 199.256 529.476C199.256 529.476 202.297 521.853 201.871 519.477C201.662 518.348 201.012 517.349 200.063 516.7C199.114 516.05 197.944 515.803 196.808 516.012C195.673 516.221 194.665 516.87 194.006 517.815C193.346 518.761 193.089 519.927 193.29 521.058Z",
    fill: "#43D1B7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M184.79 542.165C186.356 543.98 194.212 546.406 194.212 546.406C194.212 546.406 192.979 538.295 191.418 536.489C191.045 536.058 190.591 535.703 190.081 535.447C189.57 535.191 189.014 535.037 188.443 534.995C187.872 534.954 187.297 535.024 186.753 535.203C186.208 535.382 185.704 535.666 185.269 536.039C184.834 536.412 184.476 536.866 184.216 537.375C183.957 537.885 183.8 538.44 183.756 539.009C183.711 539.578 183.78 540.149 183.957 540.691C184.135 541.232 184.417 541.733 184.79 542.165Z",
    fill: "#43D1B7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M181.965 559.562C183.199 561.618 190.522 565.332 190.522 565.332C190.522 565.332 190.689 557.133 189.452 555.077C188.86 554.091 187.897 553.381 186.776 553.104C185.654 552.827 184.467 553.006 183.474 553.6C182.481 554.195 181.764 555.157 181.481 556.275C181.198 557.393 181.372 558.575 181.965 559.562Z",
    fill: "#43D1B7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M207.519 533.374C205.277 534.263 197.183 532.804 197.183 532.804C197.183 532.804 202.083 526.196 204.325 525.306C204.857 525.095 205.426 524.99 205.999 524.998C206.571 525.006 207.136 525.125 207.661 525.351C208.186 525.576 208.661 525.902 209.059 526.311C209.456 526.719 209.769 527.202 209.979 527.732C210.188 528.262 210.291 528.828 210.281 529.398C210.271 529.968 210.148 530.531 209.92 531.055C209.691 531.579 209.361 532.053 208.95 532.451C208.538 532.849 208.051 533.163 207.519 533.374Z",
    fill: "#43D1B7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 553.679C201.552 553.86 194.275 550.055 194.275 550.055C194.275 550.055 200.933 545.198 203.333 545.018C203.904 544.975 204.478 545.044 205.021 545.222C205.565 545.4 206.067 545.683 206.5 546.054C206.932 546.426 207.287 546.879 207.543 547.388C207.799 547.897 207.952 548.451 207.993 549.02C208.034 549.589 207.962 550.16 207.781 550.702C207.6 551.244 207.314 551.746 206.939 552.178C206.564 552.611 206.107 552.966 205.595 553.224C205.083 553.481 204.526 553.636 203.954 553.679Z",
    fill: "#43D1B7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M197.773 572.953C195.436 573.535 187.614 571.011 187.614 571.011C187.614 571.011 193.357 565.109 195.694 564.527C196.817 564.247 198.004 564.422 198.993 565.015C199.982 565.607 200.693 566.567 200.969 567.684C201.245 568.801 201.063 569.984 200.465 570.972C199.866 571.96 198.898 572.672 197.775 572.952L197.773 572.953Z",
    fill: "#43D1B7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M170.826 579.607C170.826 579.607 173.203 550.533 159.402 532.444C153.566 524.895 150.352 515.647 150.242 506.089C150.226 501.543 150.628 497.002 151.444 492.525",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M142.812 481.094C143.51 484.446 151.628 492.872 151.628 492.872C151.628 492.872 155.689 481.852 154.99 478.5C154.654 476.891 153.691 475.484 152.311 474.589C150.932 473.694 149.25 473.384 147.635 473.728C146.02 474.072 144.604 475.042 143.7 476.423C142.795 477.804 142.476 479.485 142.812 481.094Z",
    fill: "#0D2290"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M136.617 501.809C139.033 504.232 150.46 506.875 150.46 506.875C150.46 506.875 147.895 495.449 145.464 493.032C144.304 491.868 142.725 491.214 141.076 491.214C139.426 491.213 137.84 491.867 136.667 493.031C135.493 494.195 134.829 495.774 134.82 497.42C134.81 499.066 135.457 500.645 136.617 501.809Z",
    fill: "#0D2290"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M143.679 533.446C146.996 534.315 158.233 530.833 158.233 530.833C158.233 530.833 150.219 522.309 146.9 521.437C145.32 521.061 143.652 521.317 142.253 522.152C140.854 522.987 139.835 524.333 139.415 525.903C138.994 527.473 139.206 529.141 140.004 530.55C140.803 531.959 142.124 532.997 143.685 533.442L143.679 533.446Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M154.431 556.153C157.55 557.573 169.202 556.032 169.202 556.032C169.202 556.032 162.754 546.265 159.637 544.849C158.895 544.512 158.093 544.325 157.277 544.297C156.461 544.27 155.646 544.403 154.88 544.69C154.113 544.977 153.41 545.411 152.811 545.967C152.211 546.524 151.726 547.193 151.384 547.935C151.042 548.677 150.85 549.479 150.818 550.293C150.786 551.108 150.915 551.92 151.198 552.683C151.481 553.446 151.912 554.146 152.467 554.741C153.022 555.336 153.689 555.816 154.431 556.153Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M163.383 504.803C161.458 507.649 150.722 512.464 150.722 512.464C150.722 512.464 151.153 500.752 153.08 497.9C154.004 496.532 155.434 495.583 157.054 495.263C158.674 494.942 160.352 495.276 161.718 496.192C163.085 497.107 164.028 498.528 164.34 500.143C164.652 501.758 164.308 503.434 163.383 504.803Z",
    fill: "#0D2290"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M175.62 531.52C172.933 533.668 161.264 535.065 161.264 535.065C161.264 535.065 165.182 523.996 167.872 521.847C169.167 520.855 170.797 520.407 172.413 520.599C174.028 520.79 175.5 521.606 176.514 522.872C177.528 524.137 178.002 525.752 177.834 527.368C177.667 528.985 176.872 530.476 175.62 531.52Z",
    fill: "#0D2290"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M183.932 559.133C181.643 561.703 170.369 565.045 170.369 565.045C170.369 565.045 172.362 553.486 174.653 550.919C175.197 550.308 175.856 549.809 176.591 549.451C177.327 549.093 178.125 548.883 178.941 548.832C179.756 548.781 180.573 548.891 181.344 549.156C182.115 549.42 182.825 549.834 183.434 550.374C184.044 550.913 184.54 551.567 184.895 552.299C185.249 553.031 185.456 553.827 185.502 554.64C185.548 555.454 185.433 556.269 185.164 557.04C184.895 557.811 184.476 558.522 183.932 559.133Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M170.428 578.731C170.428 578.731 184.402 553.044 179.164 530.888C176.905 521.609 177.729 511.832 181.514 503.027C183.341 498.86 185.546 494.867 188.102 491.097",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M184.883 477.115C184.161 480.473 188.142 491.476 188.142 491.476C188.142 491.476 196.319 483.019 197.043 479.665C197.393 478.052 197.087 476.371 196.193 474.991C195.299 473.611 193.89 472.645 192.276 472.305C190.663 471.965 188.976 472.28 187.588 473.179C186.2 474.079 185.224 475.49 184.874 477.102L184.883 477.115Z",
    fill: "#43D1B7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M170.824 493.594C172.052 496.788 181.4 503.851 181.4 503.851C181.4 503.851 183.674 492.355 182.455 489.131C181.867 487.601 180.693 486.369 179.191 485.706C177.69 485.042 175.982 485.001 174.443 485.592C172.904 486.182 171.659 487.356 170.981 488.856C170.303 490.356 170.246 492.06 170.824 493.594Z",
    fill: "#43D1B7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M164.414 525.445C167.087 527.584 178.748 528.934 178.748 528.934C178.748 528.934 174.897 517.87 172.233 515.745C171.597 515.236 170.867 514.858 170.083 514.632C169.3 514.405 168.478 514.335 167.666 514.426C166.853 514.517 166.066 514.766 165.348 515.16C164.631 515.554 163.997 516.084 163.484 516.721C162.971 517.358 162.587 518.089 162.356 518.872C162.125 519.655 162.051 520.475 162.137 521.285C162.223 522.096 162.469 522.88 162.859 523.594C163.25 524.307 163.778 524.937 164.414 525.445Z",
    fill: "#43D1B7"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M164.998 550.603C167.268 553.167 178.519 556.464 178.519 556.464C178.519 556.464 176.609 544.912 174.336 542.35C173.246 541.121 171.709 540.376 170.062 540.281C168.416 540.185 166.796 540.746 165.557 541.841C164.319 542.935 163.565 544.473 163.46 546.116C163.355 547.76 163.908 549.374 164.998 550.603Z",
    fill: "#43D1B7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M194.018 507.16C191.104 508.995 179.361 509.065 179.361 509.065C179.361 509.065 184.511 498.507 187.424 496.672C188.117 496.236 188.888 495.94 189.694 495.801C190.499 495.662 191.323 495.682 192.119 495.861C192.915 496.04 193.667 496.374 194.332 496.843C194.997 497.313 195.562 497.909 195.995 498.597C196.428 499.286 196.72 500.054 196.855 500.857C196.99 501.66 196.965 502.483 196.781 503.278C196.598 504.073 196.259 504.825 195.785 505.491C195.311 506.157 194.71 506.724 194.018 507.16Z",
    fill: "#43D1B7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M194.326 536.594C191.001 537.477 179.792 534.039 179.792 534.039C179.792 534.039 187.867 525.481 191.189 524.6C191.979 524.39 192.802 524.337 193.611 524.444C194.42 524.552 195.2 524.817 195.904 525.226C196.609 525.634 197.225 526.178 197.718 526.825C198.211 527.472 198.57 528.211 198.776 528.998C198.982 529.786 199.031 530.607 198.918 531.415C198.806 532.223 198.536 533.002 198.122 533.707C197.709 534.412 197.161 535.03 196.51 535.526C195.858 536.021 195.116 536.384 194.326 536.594Z",
    fill: "#43D1B7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M190.69 565.265C187.562 566.694 175.923 565.196 175.923 565.196C175.923 565.196 182.44 555.41 185.569 553.981C187.072 553.295 188.783 553.231 190.326 553.803C191.87 554.376 193.119 555.538 193.798 557.034C194.478 558.53 194.533 560.237 193.95 561.78C193.368 563.324 192.197 564.576 190.694 565.263L190.69 565.265Z",
    fill: "#43D1B7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M458.328 573.498L465.054 639.848C465.087 640.208 465.254 640.542 465.522 640.785C465.789 641.027 466.138 641.161 466.5 641.159H500.128C500.49 641.161 500.839 641.027 501.106 640.785C501.374 640.542 501.541 640.208 501.575 639.848L508.3 573.498H458.328Z",
    fill: "url(#paint14_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M458.294 591.691L461.792 622.966H504.601L508.065 591.691H458.294Z",
    fill: "#F0F2F5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M470.367 607.396C470.367 609.937 471.12 612.421 472.532 614.533C473.943 616.646 475.95 618.292 478.297 619.265C480.644 620.237 483.227 620.491 485.719 619.996C488.211 619.5 490.5 618.276 492.297 616.48C494.093 614.683 495.317 612.394 495.812 609.902C496.308 607.41 496.054 604.827 495.081 602.48C494.109 600.133 492.463 598.126 490.35 596.715C488.238 595.303 485.754 594.55 483.213 594.55C479.806 594.55 476.539 595.903 474.129 598.312C471.72 600.722 470.367 603.989 470.367 607.396Z",
    fill: "#7788E3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M158.863 640.159H210.955C211.586 640.161 212.195 639.922 212.657 639.491C213.119 639.06 213.4 638.469 213.443 637.839L217.277 582.654C217.3 582.31 217.252 581.966 217.135 581.642C217.018 581.318 216.836 581.022 216.599 580.772C216.362 580.523 216.075 580.325 215.758 580.191C215.441 580.058 215.099 579.992 214.755 579.997H155.03C154.688 579.997 154.35 580.066 154.037 580.202C153.723 580.337 153.441 580.535 153.208 580.785C152.974 581.034 152.795 581.328 152.68 581.65C152.565 581.972 152.518 582.313 152.541 582.654L156.442 637.839C156.484 638.458 156.755 639.039 157.203 639.468C157.651 639.898 158.243 640.144 158.863 640.159Z",
    fill: "url(#paint15_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M151.129 574.751H218.622C219.978 574.751 221.077 575.85 221.077 577.206V591.532C221.077 592.888 219.978 593.987 218.622 593.987H151.129C149.773 593.987 148.674 592.888 148.674 591.532V577.206C148.674 575.85 149.773 574.751 151.129 574.751Z",
    fill: "url(#paint16_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.8,
    d: "M421 842C188.488 842 0 653.512 0 421C0 188.488 188.488 0 421 0C653.512 0 842 188.488 842 421C842 653.512 653.512 842 421 842Z",
    fill: "url(#paint17_radial)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.612 582.648C332.792 583.949 332.906 587.065 330.826 588.521L300.732 609.589C298.46 611.18 295.328 609.622 295.227 606.85L295.076 602.728C295.033 601.542 295.594 600.414 296.567 599.733L310.311 590.111C312.985 588.239 312.839 584.233 310.036 582.56L295.623 573.96C294.604 573.352 293.962 572.268 293.919 571.082L293.768 566.961C293.667 564.189 296.677 562.406 299.059 563.827L330.612 582.648Z",
    stroke: "url(#paint18_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.296 582.331C341.476 583.631 341.59 586.748 339.51 588.204L309.416 609.272C307.144 610.862 304.012 609.304 303.911 606.532L303.76 602.411C303.717 601.224 304.278 600.096 305.251 599.415L318.995 589.793C321.669 587.922 321.523 583.915 318.72 582.243L304.307 573.642C303.288 573.034 302.647 571.951 302.603 570.765L302.452 566.643C302.351 563.871 305.361 562.089 307.743 563.51L339.296 582.331Z",
    stroke: "#F0F2F5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.122 582.703C327.042 584.159 327.156 587.275 329.337 588.576L360.889 607.39C363.272 608.81 366.281 607.027 366.179 604.256L366.029 600.134C365.985 598.947 365.343 597.864 364.324 597.255L349.913 588.663C347.11 586.991 346.963 582.985 349.636 581.112L363.382 571.482C364.354 570.801 364.915 569.674 364.872 568.488L364.721 564.367C364.62 561.595 361.488 560.036 359.216 561.628L329.122 582.703Z",
    stroke: "url(#paint19_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.438 583.02C318.358 584.477 318.472 587.593 320.653 588.893L352.205 607.707C354.587 609.128 357.597 607.345 357.495 604.573L357.345 600.451C357.301 599.265 356.659 598.181 355.639 597.573L341.229 588.98C338.426 587.309 338.279 583.302 340.952 581.43L354.698 571.8C355.67 571.119 356.231 569.992 356.188 568.805L356.037 564.684C355.935 561.912 352.804 560.354 350.531 561.945L320.438 583.02Z",
    stroke: "#F0F2F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 226.244,
    y1: 139.061,
    x2: 215.311,
    y2: 377.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F7",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#758AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 310.933,
    y1: 144.133,
    x2: 310.933,
    y2: 587.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D14358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 571.287,
    y1: -6.08684,
    x2: 571.287,
    y2: 436.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D14358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7484DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 514.724,
    y1: 621.092,
    x2: 430.113,
    y2: 158.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 445.516,
    y1: 370.725,
    x2: 359.258,
    y2: 272.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D232B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 535.204,
    y1: 478.505,
    x2: 433.14,
    y2: 378.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -9710.09,
    y1: 16954,
    x2: -11144.7,
    y2: 15376.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -3075.28,
    y1: 41696.1,
    x2: -11599.1,
    y2: 46801.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EF8A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EA6B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -25516.1,
    y1: 44181.5,
    x2: -10742.7,
    y2: 54796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EF8A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EA6B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 643.522,
    y1: 604.916,
    x2: 643.522,
    y2: 354.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B3544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 380.612,
    y1: 553.935,
    x2: 260.053,
    y2: 422.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 483.18,
    y1: 570.472,
    x2: 483.18,
    y2: 568.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1C5163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2A6E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 483.213,
    y1: 573.397,
    x2: 483.213,
    y2: 570.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1B4D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#255F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -5008.63,
    y1: 2425.55,
    x2: -5609.25,
    y2: 2425.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1C5163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2A6E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 455.705,
    y1: 607.329,
    x2: 508.065,
    y2: 607.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFB",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 217.142,
    y1: 610.062,
    x2: 148.606,
    y2: 610.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC844B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9F6843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7D533D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#684739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#604238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -14825,
    y1: 3805.79,
    x2: -14189.6,
    y2: 4923.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC844B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9F6843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7D533D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#684739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#604238"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(421 421) rotate(180) scale(421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#133B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0A1F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 336.1,
    y1: 583.281,
    x2: 293.921,
    y2: 584.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 323.694,
    y1: 583.735,
    x2: 365.873,
    y2: 582.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.2069,
    height: 54.6207,
    fill: "white",
    transform: "translate(293 559.631) rotate(-2.09407)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.2069,
    height: 54.6207,
    fill: "white",
    transform: "translate(301.684 559.313) rotate(-2.09407)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.2069,
    height: 54.6207,
    fill: "white",
    transform: "matrix(-0.999332 0.0365403 0.0365403 0.999332 364.952 557)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.2069,
    height: 54.6207,
    fill: "white",
    transform: "matrix(-0.999332 0.0365403 0.0365403 0.999332 356.268 557.318)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage404AdminIcon);
export default __webpack_public_path__ + "static/media/page-404-admin-icon.dbf7a59c.svg";
export { ForwardRef as ReactComponent };